import axios from "src/lib/axios";

//list find all
export const getSimilars = (user_id = null, product_id = null) => {
  return axios.get(`/searchs/similar`, {
    params: {
      user_id: user_id,
      product_id: product_id,
    },
  });
};
